import useLanguageTree from './fallbackTranslations'
import idoniaLocales, {
  locales,
  codes,
  parseLocale,
  defaultLocale,
  selectLocales
} from './locales'
import i18n, { loadLocaleMessages, getNewVueI18n, getI18n } from './i18n'

export default useLanguageTree

export { useLanguageTree }

export {
  idoniaLocales,
  locales,
  codes,
  parseLocale,
  defaultLocale,
  selectLocales
}

export {
  i18n,
  getI18n,
  loadLocaleMessages,
  getNewVueI18n
}

export function mergeMessages (messages, i18n, id) {
  if (!i18n) {
    i18n = getI18n()
  }
  let t
  if (!i18n['_idonia' + id]) {
    for (const locale in messages) {
      i18n.mergeLocaleMessage(locale, messages[locale])
    }
    t = getFallbackTranslationFunction(i18n)
    i18n['_idonia' + id] = true
  } else {
    t = getFallbackTranslationFunction(i18n)
  }

  return {
    t,
    i18n
  }
}

export function useScopedTranslations (messages, locale) {
  const i18n = getNewVueI18n(messages)
  const { t } = useLanguageTree(i18n)
  function setLocale (locale) {
    i18n.locale = locale
  }
  setLocale(locale)
  return {
    setLocale,
    i18n,
    t
  }
}

export function getFallbackTranslationFunction (i18n = getI18n()) {
  const { t } = useLanguageTree(i18n)
  return t
}
